<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid height="calc(100vh - 320px)"
		[dataSource]="viewModel.dataSource"
		[showBorders]="true"
		(onRowRemoving)="rowRemoving($event)"
	>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing mode="row" [allowAdding]="canCreateGroups" [allowUpdating]="false" [allowDeleting]="canDeleteGroups"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>
		<dxo-pager [showPageSizeSelector]="true"></dxo-pager>
		<dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>

		<dxi-column dataField="id" caption="ID" [visible]="false" [allowEditing]="false"></dxi-column>
		<dxi-column dataField="creationDate" dataType="datetime" caption="Created on" [allowEditing]="false"></dxi-column>
		<dxi-column dataField="name" caption="Name"></dxi-column>
		<dxi-column dataField="description" caption="Description"></dxi-column>
		<dxi-column dataField="isDefaultGroup" dataType="boolean" caption="Is default"></dxi-column>
		<dxi-column caption="Details" [width]="150" [allowFiltering]="false" [allowSorting]="false" cellTemplate="detailsCellTemplate"></dxi-column>
		<dxi-column type="buttons" [width]="56">
			<dxi-button name="delete"></dxi-button>
		</dxi-column>

		<div class="details-cell" *dxTemplate="let cell of 'detailsCellTemplate'">
			<dx-button text="Open details" icon="far fa-external-link" stylingMode="outlined" (onClick)="openGroupFromCell(cell)"></dx-button>
		</div>
	</dx-data-grid>
</ng-container>
